import React from 'react';
import { Box, Container } from '@mui/material';
import SiteFooter from '@components/layout/SiteFooter';
import { brandColors } from '@config/brandTokens';

interface AuthPageShellProps {
  children: React.ReactNode;
  /** Wider forms (player/coach registration) use "md". */
  maxWidth?: 'sm' | 'md';
}

/** Login / register pages — form card + footer attribution. Logo lives on the card. */
const AuthPageShell: React.FC<AuthPageShellProps> = ({ children, maxWidth = 'sm' }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: brandColors.ice,
    }}
  >
    <Container maxWidth={maxWidth} sx={{ flex: 1, py: { xs: 3, md: 4 } }}>
      {children}
    </Container>
    <SiteFooter compact />
  </Box>
);

export default AuthPageShell;
